export default {"src":"/_next/static/media/accord-logo.5e8958e0.svg","height":106,"width":383,"blurWidth":0,"blurHeight":0};